function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0.830058L12 11.8437C12 12.0334 11.8482 12.1851 11.6586 12.1851H7.65016C7.46049 12.1851 7.30875 12.0334 7.30875 11.8437V10.4654C7.30875 10.2757 7.46049 10.124 7.65016 10.124H9.93888L9.93888 2.5624L7.65017 2.5624C7.46049 2.5624 7.30875 2.41066 7.30875 2.22099L7.30876 0.830057C7.30876 0.640385 7.46049 0.488647 7.65017 0.488647L11.6586 0.488648C11.8482 0.488648 12 0.640385 12 0.830058ZM8.19384 6.0146C8.40881 6.17898 8.40881 6.50775 8.19384 6.67213L4.74181 9.28961C4.47627 9.49192 4.08428 9.30225 4.08428 8.96084L4.08428 7.54462H0.341411C0.151739 7.54462 -1.65815e-08 7.39288 0 7.20321L1.50341e-07 5.48351C1.66922e-07 5.29384 0.151739 5.1421 0.341411 5.1421H4.09692V3.72588C4.09692 3.38447 4.48891 3.1948 4.75445 3.39712L8.19384 6.0146Z",
  fill: "white"
});

var SvgSignInIcon = function SvgSignInIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignInIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-in-icon.cc566e7c.svg";
export { ForwardRef as ReactComponent };